module.exports = __webpack_public_path__ + "assets/GoldBeta2x.81063c166c03eef8a11dd5e5116afc11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldBeta2x.png
// module id = 805
// module chunks = 0